import { HTTPCallsService } from "./http.service";
import { AlertService } from "./alert.service";
import { Injectable } from "@angular/core";

import { MissionService } from "./mission.service";
import { DataStore } from "./dataStore.service";

@Injectable()
export class ThingsSyncService {
  loading: boolean;
  isSendingStatus: boolean;
  timestamp: number;
  selectedThingId: string;
  displayModel = "none";
  oldStatus: string = "";
  isHttpcontrol: boolean;
  isSync: boolean = false;
  missions = ["ThingSyncCompleted"];
  noOfPages: number = 1;
  pageCount: number = 1;
  storeArray = [];

  constructor(
    private httpService: HTTPCallsService,
    private alertService: AlertService,
    private missionService: MissionService,

    private dataStore: DataStore
  ) { }

  public syncThingsData(pageCount): boolean {
    this.pageCount = pageCount;
    this.httpService.getThingData(this.pageCount).subscribe(syncData => {
      var syncDataArray = Object.keys(syncData["data"]).map(function (
        valueIndex
      ) {
        let data = syncData["data"][valueIndex];
        return data;
      });
      this.storeArray = this.storeArray.concat(syncDataArray);
      this.noOfPages = syncData["totalPages"];
      if (this.noOfPages != this.pageCount) {
        this.pageCount = this.pageCount + 1;
        this.syncThingsData(this.pageCount);
      } else {
        // console.log("Data before storage", this.storeArray);
        this.dataStore.parseThingData(this.storeArray);
        this.storeArray = [];
      }
    });
    return true;
  }
}
